(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["danny-product-buster"] && !Shopify.designMode) return;
  try {
    const initializeDannyProductBuster = () => {
    const product = document.querySelector('.product');
    const stickyBar = document.querySelector('[data-danny-mobile-buybar]');
    const stickyButton = stickyBar?.querySelector('[data-danny-sticky-submit]');
    const stickyPrice = stickyBar?.querySelector('[data-danny-sticky-price]');
    const mainButton = product?.querySelector('.product-form__submit');
    const priceContainer = product?.querySelector('[id^="price-"]');
    const description = product?.querySelector('.product__description');
    const descriptionLabels = document.querySelector('[data-danny-description-labels]');

    if (!product || !stickyBar || !stickyButton || !mainButton) return;

    if (stickyBar.parentElement !== document.body) document.body.append(stickyBar);

    stickyButton.addEventListener('click', () => {
      if (mainButton.disabled) {
        product.querySelector('variant-selects, variant-radios, .product-form__input')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      mainButton.click();
    });

    const synchronizeButton = () => {
      stickyButton.disabled = mainButton.disabled;
      stickyButton.textContent = mainButton.textContent.trim();
    };

    const synchronizePrice = () => {
      if (!stickyPrice || !priceContainer) return;
      const price = priceContainer.querySelector('.price');
      const priceElement = price?.classList.contains('price--on-sale')
        ? price.querySelector('.price-item--sale')
        : price?.querySelector('.price-item--regular');
      const priceText = priceElement?.textContent.trim();
      if (priceText) stickyPrice.textContent = priceText;
    };

    const setStickyVisibility = (visible) => {
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', String(!visible));
    };

    const buttonObserver = new IntersectionObserver(([entry]) => {
      setStickyVisibility(!entry.isIntersecting);
    }, { threshold: 0 });

    synchronizeButton();
    synchronizePrice();
    buttonObserver.observe(mainButton);
    new MutationObserver(synchronizeButton).observe(mainButton, { attributes: true, childList: true, subtree: true });
    if (priceContainer) {
      new MutationObserver(synchronizePrice).observe(priceContainer, { attributes: true, childList: true, subtree: true });
    }

    if (description && description.scrollHeight > 520 && !document.querySelector('.danny-description-toggle')) {
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'danny-description-toggle';
      toggle.textContent = descriptionLabels?.dataset.showLabel || '';
      toggle.setAttribute('aria-expanded', 'false');
      description.after(toggle);
      toggle.addEventListener('click', () => {
        const expanded = description.classList.toggle('danny-description-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.textContent = expanded
          ? descriptionLabels?.dataset.hideLabel || ''
          : descriptionLabels?.dataset.showLabel || '';
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDannyProductBuster, { once: true });
  } else {
    initializeDannyProductBuster();
  }
  } catch(e) { console.error(e); }
})();

})();
